import React from "react";
import { Container, Button, Form } from "react-bootstrap";
import ProfileImage from "./ProfileImage";
import PersonalDetails from "./PersonalDetails";
import ChangePassword from "./ChangePassword";

const Settings = () => {
    return (
        <Container className="my-5">
            <h3 className="mb-3">Account Settings</h3>
            <Form>
                <ProfileImage />
                <PersonalDetails />
                <ChangePassword />
            </Form>
        </Container>
    );
};

export default Settings;
